import { render, staticRenderFns } from "./RecoverSet.vue?vue&type=template&id=6e83d234&scoped=true"
import script from "./RecoverSet.vue?vue&type=script&lang=js"
export * from "./RecoverSet.vue?vue&type=script&lang=js"
import style0 from "./RecoverSet.vue?vue&type=style&index=0&id=6e83d234&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83d234",
  null
  
)

export default component.exports